<template>
  <div class="page rel bg-bottom bg-cover" style="background-color: #52b1ff">
    <Topbar />
    <div class="abs-center-hv color-white" style="margin: -1rem 0 0">
      <div class="rfs14 fwb m-b-8 tc">尚网授权代理商查询</div>
      <div flex="cross:center" style="height: 35px">
        <van-field
          class="rfs12"
          v-model="name"
          center
          clearable
          label=""
          placeholder="输入您要查询的代理商名称"
          style="width: 2.05rem; height: 100%"
        >
        </van-field>
        <van-button size="small" class="btn-search" type="primary">查询</van-button>
      </div>
    </div>
    <Contact type="info" style="bottom: 0.6rem" />
  </div>
</template>
<script>
import Base from './Base';

export default {
  name: '',
  props: {},
  extends: Base,
  data() {
    return {
      name: '',
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.btn-search {
  height: 100% !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  border-color: #0078ff;
  border-radius: 0;
  background: #0078ff;
}
</style>
